import { render } from "./VodClipTrimmingModal.vue?vue&type=template&id=7e232250"
import script from "./VodClipTrimmingModal.vue?vue&type=script&lang=js"
export * from "./VodClipTrimmingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__